<template>
    <table class="font14 d-inline-block"><tbody>
        <tr v-for="(platz, i) in ergebnis" :key="i" >
            <td v-if="(i===0 || (i>0 && ergebnis[i-1]?.platz !== platz.platz)) && platz?.team"
                class="px-2 text-center">
                <div :class="[{[platz.class]: platz.class}, {['empty']: !platz.class}, 'platzierung']">
                    <div class="platzierungText font-weight-bold">
                        {{ platz.platz }}<span v-if="!platz.class">.</span>
                    </div>
                </div>
            </td>
            <td v-else class="empty platzierung"></td>
            <td v-if="platz.team">{{platz?.team?.settings?.name}}</td>
        </tr>
    </tbody></table>
</template>

<script>
export default {
    name: "meisterschaftPrintErgebnisTab",
    props: ['ergebnis'],
}
</script>

<style scoped>
    .font14 { font-size: 14px; }
    .platzierung { width: 32px; height: 32px; border-radius: 20px;
        box-sizing: border-box;
        border-width: 16px; border-style: solid;
        position: relative; margin-bottom: 2px}
    .platzierungText {position: absolute; top: -10px; left: -4px}
    .gold { border-color: gold; }
    .silver { border-color: silver; }
    .bronze { border-color: #cd7f32;}
    .empty { border-color: white;}
</style>